import React from 'react';
import { useTranslation } from 'react-i18next';
import { FaPlus } from 'react-icons/fa';

const VehicleCard = ({ car, isSelected, onClick, isAddButton = false }) => {
  const { t } = useTranslation();

  // Color mapping function to convert car colors to tailwind color classes
  const getColorClasses = (color, status) => {
    // Default to purple if color is missing or empty
    if (!color || color.trim() === "") {
      return {
        bg: "from-purple-600 via-purple-500 to-purple-400 dark:from-purple-900 dark:via-purple-800 dark:to-purple-700",
        bar: "from-purple-400 via-purple-300 to-purple-200",
        text: "text-purple-100 dark:text-purple-200",
        dot: status === "Activ" ? "bg-purple-400" : "bg-yellow-400",
        panel: "from-transparent via-purple-100/50 dark:via-purple-900/50 to-transparent",
        plate: "bg-purple-50 dark:bg-purple-900/30 text-purple-700 dark:text-purple-300"
      };
    }

    // Normalize color to lowercase
    const normalizedColor = color.toLowerCase();
    const baseClasses = {
      // Map car colors to tailwind colors
      negru: {
        bg: `from-slate-200 via-white to-slate-300 dark:from-slate-900 dark:via-slate-800 dark:to-slate-700`,
        bar: `from-slate-600 via-slate-500 to-slate-400`,
        text: `text-slate-700 dark:text-slate-300`,
        dot: status === "Activ" ? "bg-slate-900 " : "bg-amber-400 ",
        panel: `from-transparent via-slate-100/50 dark:via-slate-800/50 to-transparent`,
        plate: `bg-slate-100 dark:bg-slate-800 text-slate-800 dark:text-slate-200`
      },
      argintiu: {
        bg: `from-slate-100 via-white to-slate-200 dark:from-slate-900 dark:via-slate-800 dark:to-slate-600`,
        bar: `from-slate-400 via-slate-300 to-slate-200`,
        text: `text-slate-600 dark:text-slate-300`,
        dot: status === "Activ" ? "bg-slate-400 " : "bg-amber-400 ",
        panel: `from-transparent via-slate-50/50 dark:via-slate-900/50 to-transparent`,
        plate: `bg-slate-50 dark:bg-slate-700 text-slate-700 dark:text-slate-300`
      },
      alb: {
        bg: `from-slate-50 via-white to-slate-100 dark:from-slate-900 dark:via-slate-800 dark:to-slate-700`,
        bar: `from-slate-200 via-slate-100 to-white`,
        text: `text-slate-800 dark:text-white`,
        dot: status === "Activ" ? "bg-white " : "bg-amber-400 ",
        panel: `from-transparent via-white/70 dark:via-slate-900/50 to-transparent`,
        plate: `bg-white dark:bg-slate-800 text-slate-800 dark:text-white`
      },
      albastru: {
        bg: `from-slate-100 via-white to-blue-200 dark:from-slate-900 dark:via-slate-800 dark:to-blue-900`,
        bar: `from-blue-400 via-blue-300 to-blue-200`,
        text: `text-blue-600 dark:text-blue-400`,
        dot: status === "Activ" ? "bg-blue-400 " : "bg-amber-400 ",
        panel: `from-transparent via-blue-50/30 dark:via-blue-900/20 to-transparent`,
        plate: `bg-blue-50 dark:bg-blue-900/30 text-blue-700 dark:text-blue-300`
      },
      rosu: {
        bg: `from-slate-100 via-white to-rose-200 dark:from-slate-900 dark:via-slate-800 dark:to-rose-900`,
        bar: `from-rose-400 via-rose-300 to-rose-200`,
        text: `text-rose-600 dark:text-rose-400`,
        dot: status === "Activ" ? "bg-rose-400 " : "bg-amber-400 ",
        panel: `from-transparent via-rose-50/30 dark:via-rose-900/20 to-transparent`,
        plate: `bg-rose-50 dark:bg-rose-900/30 text-rose-700 dark:text-rose-300`
      },
      verde: {
        bg: `from-slate-100 via-white to-emerald-200 dark:from-slate-900 dark:via-slate-800 dark:to-emerald-900`,
        bar: `from-emerald-400 via-emerald-300 to-emerald-200`,
        text: `text-emerald-600 dark:text-emerald-400`,
        dot: status === "Activ" ? "bg-emerald-400 " : "bg-amber-400 ",
        panel: `from-transparent via-emerald-50/30 dark:via-emerald-900/20 to-transparent`,
        plate: `bg-emerald-50 dark:bg-emerald-900/30 text-emerald-700 dark:text-emerald-300`
      },
      maro: {
        bg: `from-slate-100 via-white to-amber-200 dark:from-slate-900 dark:via-slate-800 dark:to-amber-900`,
        bar: `from-amber-500 via-amber-400 to-amber-300`,
        text: `text-amber-700 dark:text-amber-400`,
        dot: status === "Activ" ? "bg-amber-400 " : "bg-amber-400 ",
        panel: `from-transparent via-amber-50/30 dark:via-amber-900/20 to-transparent`,
        plate: `bg-amber-50 dark:bg-amber-900/30 text-amber-700 dark:text-amber-300`
      },
      portocaliu: {
        bg: `from-slate-100 via-white to-orange-200 dark:from-slate-900 dark:via-slate-800 dark:to-orange-900`,
        bar: `from-orange-400 via-orange-300 to-orange-200`,
        text: `text-orange-600 dark:text-orange-400`,
        dot: status === "Activ" ? "bg-orange-400 " : "bg-amber-400 ",
        panel: `from-transparent via-orange-50/30 dark:via-orange-900/20 to-transparent`,
        plate: `bg-orange-50 dark:bg-orange-900/30 text-orange-700 dark:text-orange-300`
      },
      // portocaliu: {
      //   bg: `from-slate-100 via-white to-orange-200 dark:from-slate-900 dark:via-slate-800 dark:to-orange-900`,
      //   bar: `from-orange-400 via-orange-300 to-orange-200`,
      //   text: `text-orange-600 dark:text-orange-400`,
      //   dot: status === "Activ" ? "bg-orange-400 " : "bg-amber-400 ",
      //   panel: `from-transparent via-orange-50/30 dark:via-orange-900/20 to-transparent`,
      //   plate: `bg-orange-50 dark:bg-orange-900/30 text-orange-700 dark:text-orange-300`
      // },
      gri: {
        bg: `from-slate-100 via-white to-slate-200 dark:from-slate-900 dark:via-slate-800 dark:to-slate-600`,
        bar: `from-slate-400 via-slate-300 to-slate-200`,
        text: `text-slate-600 dark:text-slate-300`,
        dot: status === "Activ" ? "bg-slate-400 " : "bg-amber-400 ",
        panel: `from-transparent via-slate-50/50 dark:via-slate-900/50 to-transparent`,
        plate: `bg-slate-50 dark:bg-slate-700 text-slate-700 dark:text-slate-300`
      }
    };
    // Try to match the car color with our predefined colors, or default to silver
    let colorClass = baseClasses[normalizedColor] || baseClasses.silver;

    // If the car status is not active, blend with amber to indicate it's not active
    // if (status !== "Activ") {
    //   colorClass.dot = "bg-amber-400";
    //   // We keep the color styling but add an amber overlay effect
    // }
    return colorClass;
  };

  const colorClasses = !isAddButton ? getColorClasses(car.color, car.status) : null;

  const cardClasses = isAddButton
    ? `relative bg-gradient-to-br from-slate-50 via-slate-100 to-slate-200 dark:from-slate-800 dark:via-slate-800/50 dark:to-slate-900/50 rounded-xl overflow-hidden w-full sm:max-w-sm mx-auto  hover:cursor-pointer `
    : `relative bg-gradient-to-br ${colorClasses.bg} rounded-xl overflow-hidden w-full sm:max-w-sm mx-auto hover:border-purple-100 dark:hover:border-purple-800 ${isSelected ? "  hover:rounded-xl hover:cursor-pointer" : "  hover:cursor-pointer"}`;

  const topBarClasses = isAddButton
    ? "h-2 bg-gradient-to-r from-purple-200 via-purple-100 to-purple-50 dark:from-purple-800/50 dark:via-purple-900/30 dark:to-purple-900/20"
    : `h-2 bg-gradient-to-r ${colorClasses.bar}`;

  return (
    <div
      className={cardClasses}
      onClick={onClick}
    >
      {/* Futuristic status indicator */}
      <div className={topBarClasses}></div>

      <div className="px-4 py-2 sm:p-6">
        {/* Tech-inspired header */}
        <div className="flex justify-between items-center">
          {isAddButton ? (
            <h3 className="text-base sm:text-lg font-bold tracking-tight text-transparent">
              Placeholder
            </h3>
          ) : (
            <h3 className="text-base sm:text-lg font-bold tracking-tight text-slate-900 dark:text-blue-50 truncate">
              {car.make} <span className={colorClasses.text}>{car.model}</span>
            </h3>
          )}
        </div>

        {/* Futuristic specs panel */}
        {isAddButton ? (
          <div className="text-sm text-slate-600 dark:text-slate-300 flex flex-col gap-2 rounded-lg py-3">
            <p className="flex justify-center items-center">
              <FaPlus className="h-6 w-6 hover:text-purple-600 dark:hover:text-purple-400" />
            </p>
            <p className="flex justify-center items-center">
              <span className="font-semibold hover:text-purple-600 dark:hover:text-purple-400">{t('vehicles.addCar')}</span>
            </p>
          </div>
        ) : (
          <div className={`text-sm text-slate-600 dark:text-slate-300 flex flex-col gap-2 bg-gradient-to-r ${colorClasses.panel} rounded-lg py-3`}>
            <p className="flex justify-between items-center">
              <span className="flex items-center dark:text-slate-200 mr-2">
                <svg className={`w-3 h-3 mr-1 ${colorClasses.text}`} xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" d="M6.75 3v2.25M17.25 3v2.25M3 18.75V7.5a2.25 2.25 0 012.25-2.25h13.5A2.25 2.25 0 0121 7.5v11.25m-18 0A2.25 2.25 0 005.25 21h13.5A2.25 2.25 0 0021 18.75m-18 0v-7.5A2.25 2.25 0 015.25 9h13.5A2.25 2.25 0 0121 11.25v7.5" />
                </svg>
                {t('vehicles.year')}:
              </span>
              <span className="font-mono">{car.year}</span>
            </p>
            <p className="flex justify-between items-center">
              <span className="flex items-center dark:text-slate-200 mr-2">
                <svg className={`w-3 h-3 mr-1 ${colorClasses.text}`} xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" d="M15 9h3.75M15 12h3.75M15 15h3.75M4.5 19.5h15a2.25 2.25 0 002.25-2.25V6.75A2.25 2.25 0 0019.5 4.5h-15a2.25 2.25 0 00-2.25 2.25v10.5A2.25 2.25 0 004.5 19.5zm6-10.125a1.875 1.875 0 11-3.75 0 1.875 1.875 0 013.75 0zm1.294 6.336a6.721 6.721 0 01-3.17.789 6.721 6.721 0 01-3.168-.789 3.376 3.376 0 016.338 0z" />
                </svg>
                {t('vehicles.registrationNumber')}:
              </span>
              <span className={`${colorClasses.plate} px-2 py-0.5 rounded font-mono`}>
                {car.plate}
              </span>
            </p>
          </div>
        )}

        {/* Futuristic bottom bar */}
        <div className={`mt-3 pt-2 flex justify-between ${isAddButton ? 'border-t border-transparent' : 'border-t border-slate-100 dark:border-slate-700'}`}>
          {isAddButton ? (
            <div className="text-xs text-transparent">
              Placeholder
            </div>
          ) : (
            <div className="flex justify-between w-full">
              <div className={`text-xs ${colorClasses.text}`}>
                {car.owner && (
                  <span className="font-medium">
                    {t('vehicles.owner')}
                  </span>
                )}
              </div>
              <div className={`text-xs ${colorClasses.text}`}>
                {car.year} {t('vehicles.model')}
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  )
}

export default VehicleCard
